"use strict";

import angular from "angular";
/**
 * @component nuLogo
 * O <nu-logo> è um componente que é usado para mostrar a logo do Nucont
 */

import template from "./logo.component.html";
import "./logo.component.scss";

const name = "nuLogo";
const factory = [
    function () {
        return {
            restrict: "E",
            template,
            scope: {
                type: "@",
                orientation: "@"
            }
        };
    }
];
angular.module("nucont.shared").directive(name, factory);
export default { name, factory };
